<template>
    <div class="bottomtabbar-box" v-if="appObj">
        <BottomTabBarItemView :isActive="activeTabItem == appObj.left1" class="bottomtabbar-item"
            @click="onClickBottomTab($event, appObj.left1)">
            <template #itemicon>
                <img v-if="appObj.left1.ignore.icon_normal_url" :src="appObj.left1.ignore.icon_normal_url" />
            </template>
            <template #itemiconactive>
                <img v-if="appObj.left1.ignore.icon_select_url" :src="appObj.left1.ignore.icon_select_url" />
            </template>
            <template #itemtext>
                <div>{{ appObj.left1.name }}</div>
            </template>
        </BottomTabBarItemView>
        <BottomTabBarItemView :isActive="activeTabItem == appObj.left2" class="bottomtabbar-item"
            @click="onClickBottomTab($event, appObj.left2)">
            <template #itemicon>
                <img v-if="appObj.left2.ignore.icon_normal_url" :src="appObj.left2.ignore.icon_normal_url" />
            </template>
            <template #itemiconactive>
                <img v-if="appObj.left2.ignore.icon_select_url" :src="appObj.left2.ignore.icon_select_url" />
            </template>
            <template #itemtext>
                <div>{{ appObj.left2.name }}</div>
            </template>
        </BottomTabBarItemView>
        <BottomTabBarItemView :isActive="activeTabItem == appObj.right1" class="bottomtabbar-item"
            @click="onClickBottomTab($event, appObj.right1)">
            <template #itemicon>
                <img v-if="appObj.right1.ignore.icon_normal_url" :src="appObj.right1.ignore.icon_normal_url" />
            </template>
            <template #itemiconactive>
                <img v-if="appObj.right1.ignore.icon_select_url" :src="appObj.right1.ignore.icon_select_url" />
            </template>
            <template #itemtext>
                <div>{{ appObj.right1.name }}</div>
            </template>
        </BottomTabBarItemView>
        <BottomTabBarItemView :isActive="activeTabItem == appObj.right2" class="bottomtabbar-item"
            @click="onClickBottomTab($event, appObj.right2)">
            <template #itemicon>
                <img v-if="appObj.right2.ignore.icon_normal_url" :src="appObj.right2.ignore.icon_normal_url" />
            </template>
            <template #itemiconactive>
                <img v-if="appObj.right2.ignore.icon_select_url" :src="appObj.right2.ignore.icon_select_url" />
            </template>
            <template #itemtext>
                <div>{{ appObj.right2.name }}</div>
            </template>
        </BottomTabBarItemView>

        <div class="divider"></div>
    </div>
</template>
  
<script>

import BottomTabBarItemView from './BottomTabBarItemView.vue';
import emitter from '@/utils/eventbus';

export default {
    name: "BottomTabBarView",
    components: {
        BottomTabBarItemView
    },
    props: ['appObj'],
    data() {
        return {
            activeTabItem: {}
        }
    },
    methods: {
        /**
         * 点击底部导航栏选项
         */
        onClickBottomTab(event, bottomTab) {
            this.selectBottomTab(bottomTab)
        },
        /**
         * 选中底部导航栏
         */
        selectBottomTab(bottomTab) {
            this.activeTabItem = bottomTab
            emitter.emit('onComponentChange', { type: 'bottomtab', name: '底部导航栏', component: bottomTab })
            emitter.emit('onBottomTabChange', bottomTab)
        }
    },
    watch: {
        appObj(newValue) {
            //默认选中第一个吧 后续可能按配置选择[添加判断逻辑]
            console.log('设置appObj newValue', newValue)
            this.selectBottomTab(newValue.left1)
        }
    }
}
</script>
  
<style scoped lang="less">
img {
    width: 25px;
    height: 25px;
    object-fit: contain;
}

.bottomtabbar-box {
    display: flex;
    flex-wrap: nowrap;
    height: 50px;
    // background-color: rgba(0, 0, 0, 0.5);
    position: relative;

    .bottomtabbar-item {
        flex: 1;
        font-size: smaller;
    }

    .divider {
        width: 100%;
        height: 1px;
        background: #F5F5F5;
        position: absolute;
        top: 0;
        left: 0;
    }
}
</style>